import Imgix from 'react-imgix';
import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Animation, Shadows } from '../../../theme';
const Styles = labelStyles('Img', {
    root: css `
    all: unset;
    box-sizing: border-box;
    transition: box-shadow ${Animation.transitionDuration}
      ${Animation.transitionTimingFunction};
    max-width: 100%;
  `,
});
const defaultProps = {
    borderRadius: 5,
    loading: 'lazy',
};
export const Img = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    const sharedProps = {
        className: props.className,
        css: props.className ? undefined : Styles.root,
        height: props.height,
        alt: props.alt || '',
        'aria-hidden': props.ariaHidden,
        'data-testid': 'img',
        loading: props.loading,
        onError: props.onError,
        onLoad: props.onLoad,
        sizes: props.sizes,
        src: props.src,
        width: props.width,
        style: !props.className
            ? {
                display: props.isBlock ? 'block' : undefined,
                width: props.isFullWidth ? '100%' : props.width,
                height: props.height,
                borderRadius: props.borderRadius,
                boxShadow: props.shadow && Shadows[props.shadow],
                objectFit: props.objectFit,
                objectPosition: props.objectPosition,
            }
            : undefined,
    };
    if (!props.src.includes('imgix.net')) {
        return (isolateComponent("img", Object.assign({}, sharedProps)));
    }
    return (isolateComponent(Imgix, { className: sharedProps.className, css: sharedProps.css, height: sharedProps.height, htmlAttributes: {
            alt: sharedProps.alt,
            'aria-hidden': sharedProps['aria-hidden'],
            'data-testid': sharedProps['data-testid'],
            loading: sharedProps.loading,
            onError: sharedProps.onError,
            onLoad: sharedProps.onLoad,
            style: sharedProps.style,
        }, imgixParams: {
            ar: props.aspectRatio,
            fit: props.aspectRatio || props.width || props.height || props.sizes
                ? 'crop'
                : undefined,
        }, sizes: sharedProps.sizes, src: sharedProps.src, width: sharedProps.width }));
};
//# sourceMappingURL=Img.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
